/**
 * This file is auto-generated from ProfilePage.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const successMessage: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Profile updated successfully!';
        case 'pl':
            return 'Profil został pomyślnie zaktualizowany!';
    }
};
